import React, { useState } from 'react'
import ModelButton from '../modelBtn/modelButton'
import PaginatedList from '../../utils/paginatedList'
import Layout from '../../pages/layout'
import ShortCourseDetailModal from './shortCourseDetailModal'
import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'

const GeneralCardsPage = ({ data }) => {
  const [currentCourse, setCurrentCourse] = useState(null)
  const title = data?.title
  const bg =
    data?.backgroundImage != null
      ? retrunAssets(data?.backgroundImage[0]?.url)
      : ''

  const coursesList = data?.courseList?.items?.map((item, index) => {
    let item1 = item?.content?.properties
    return {
      img:
        item1?.backgroundImage != null
          ? retrunAssets(item1?.backgroundImage[0]?.url)
          : returnNotImage(),
      title: item1?.title,
      description: DecodeHtml({ html: item1?.content?.markup }),

      children: (
        <ShortCourseDetailModal
          url={
            item1?.link != null && item1?.link?.length > 0
              ? item1?.link[0]?.url
              : null
          }
        />
      )
    }
  })
  return (
    <>
      <Layout title={title} bg={bg}>
        <PaginatedList
          data={coursesList}
          renderCard={(course, index) => (
            <div
              key={index}
              onClick={() => setCurrentCourse(course)}
              className='bg-white rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition-shadow duration-300'
            >
              <img
                src={course.img}
                alt={course.title}
                height={300}
                className='w-full h-auto min-h-[300px] object-cover bg-gray-100 rounded-t-lg'
              />
              <div className='p-6'>
                <h2 className='text-lg font-semibold'>{course.title}</h2>
                <p className='text-gray-700 mt-2 text-sm'>
                  {course.description}
                </p>
              </div>
            </div>
          )}
          pageSize={6}
          innerClassName='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-8'
          className='flex flex-col gap-8'
        />
      </Layout>
      {currentCourse && (
        <ModelButton
          modalOpen={currentCourse != null}
          close={() => setCurrentCourse(null)}
        >
          {currentCourse?.children}
        </ModelButton>
      )}
    </>
  )
}

export default GeneralCardsPage
